import { useEffect, useMemo, useRef, useState } from "react";
import { patternSvg } from "@/lib/categoryPatterns";

// Seeded category pattern square; very slow drift only while on screen.
export const CategoryPattern = ({ k, seed, className = "", testId }) => {
  const ref = useRef(null);
  const [on, setOn] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || !("IntersectionObserver" in window)) return undefined;
    const io = new IntersectionObserver(([e]) => setOn(e.isIntersecting));
    io.observe(el);
    return () => io.disconnect();
  }, []);
  const html = useMemo(() => patternSvg(k, seed), [k, seed]);
  if (!html) return null;
  return <span ref={ref} data-testid={testId} data-pattern={k} data-anim={on ? "running" : "paused"} className={`cat-pattern block overflow-hidden ${className}`} dangerouslySetInnerHTML={{ __html: html }} />;
};
